import { createSelector } from "reselect";
import { NAMESPACE } from "./constants";

// Base selector
export const getLenndFlagsState = state => state[NAMESPACE];

// Derived selectors
export const getLenndFlags = createSelector(
  getLenndFlagsState,
  state => state?.flags || {}
);

export const getLenndFlagsLoading = createSelector(
  getLenndFlagsState,
  state => state?.loading || false
);

export const getLenndFlagsError = createSelector(
  getLenndFlagsState,
  state => state?.error || null
);

// Feature flag selector
export const selectFeatureFlag = flagName =>
  createSelector(getLenndFlags, flags => flags[flagName] || false);
